import { useState } from 'react';
import type { TsAlertTemplateListItemDto } from '@/api/types/tsTemplates';

interface TemplateLoaderListProps {
  items: TsAlertTemplateListItemDto[];
  loading: boolean;
  onUse: (id: number) => void;
}

// Right-column "Load Predefined Template" accordion (collapsed by default).
export function TemplateLoaderList({ items, loading, onUse }: TemplateLoaderListProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="card custom-card mb-2">
      <div
        className={`card-header p-2 d-flex align-items-center justify-content-between${open ? ' fk-accordion-open' : ''}`}
        role="button"
        onClick={() => setOpen((o) => !o)}
      >
        <div className="card-title mb-0">Load Predefined Template ({items.length})</div>
        <i className={`fe ${open ? 'fe-chevron-up' : 'fe-chevron-down'}`} />
      </div>
      {open && (
        <div className="card-body p-2">
          {loading ? (
            <div className="text-center text-muted py-2">
              <i className="fa fa-spinner fa-spin me-1" />
              Loading…
            </div>
          ) : items.length === 0 ? (
            <div className="text-center text-muted py-2 fs-13">No templates.</div>
          ) : (
            items.map((t) => (
              <div key={t.id} className="d-flex align-items-center justify-content-between py-1 border-bottom">
                <span className="fs-13 fw-semibold text-truncate">{t.profileTag}</span>
                <button type="button" className="btn btn-sm btn-outline-primary" title="Use Template" onClick={() => onUse(t.id)}>
                  <i className="fa fa-pencil" />
                </button>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
